var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17969 10.2637C9.06763 10.3945 9 10.5645 9 10.75C9 11.1641 9.33569 11.5 9.75 11.5H14.25C14.6643 11.5 15 11.1641 15 10.75C15 10.3359 14.6643 10 14.25 10H9.75C9.52173 10 9.31714 10.1016 9.17969 10.2637Z",
    fill: "#505768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.5C2 7.32812 2.67163 8 3.5 8V18C3.5 19.6562 4.84326 21 6.5 21H17.5C19.1567 21 20.5 19.6562 20.5 18V8C21.3284 8 22 7.32812 22 6.5V4.5C22 4.29688 21.9595 4.10156 21.886 3.92383C21.6604 3.38086 21.1248 3 20.5 3H3.5C3.30664 3 3.12183 3.03711 2.95215 3.10547C2.8811 3.13281 2.81274 3.16602 2.74756 3.20312C2.30054 3.46289 2 3.94531 2 4.5V6.5ZM20.5 4.5H3.5V6.5H20.5V4.5ZM5 18V8H19V18C19 18.8281 18.3284 19.5 17.5 19.5H6.5C6.07812 19.5 5.69702 19.3262 5.42456 19.0449C5.16187 18.7754 5 18.4062 5 18Z",
    fill: "#505768"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon_cart.a10c1d42669ef0a0b95906f401868647.svg";
export { ForwardRef as ReactComponent };